import { createContext } from "react";
import { MapContextProps } from "../../interfaces/maps.types";



export const MapContext =  createContext({} as MapContextProps)